import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import React from 'react';
import { APPLICATION_TITLE, FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
const Logo: FC = () => {
  const router = useRouter();
  const title = APPLICATION_TITLE.replace('سامانه آموزش مجازی ', '');
  const isHomePage = router.pathname === '/';
  const Component = isHomePage ? 'h1' : 'span';
  return <Link href={LINKS.HOME} className="flex flex-row items-center justify-between gap-3" data-sentry-element="Link" data-sentry-component="Logo" data-sentry-source-file="Logo.tsx">
      <Image width={40} height={32} src={`${FILE_BROWSER_URL}/img/img-logo.svg`} alt="لوگو آی نو" data-sentry-element="Image" data-sentry-source-file="Logo.tsx" />
      <Component className="pt-2  text-xl font-bold" data-sentry-element="Component" data-sentry-source-file="Logo.tsx">{title}</Component>
    </Link>;
};
export default React.memo(Logo);